import groupData from './mock/getAuthGroup.json' // restful api를 사용하지 않을 경우
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'

export function getGroupData(isNotify){

  let isTest = false
  if (!isUseAPI() || isTest) {
    return new Promise(function(resolve, reject) {
      let res = groupData
      console.log("api", res )
      resolve(res.msg)      
    })
  }

  return request({
    url: `/api/getGroupData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
    
  })
}

export function updateGroupData(param,isNotify){
  return request({
    url: `/api/updateGroupData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data : param,
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

export function deleteGroupData(param,isNotify){
  return request({
    url:'/api/deleteGroupData',
    method:'POST',
    meta:{apiVersion:'1.0.0'},
    headers:{ 'Content-Type': 'application/json;charset=utf8' },
    data : param,
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}
